import { BaseService } from '../../infra/base.service'
import type { TagEntity } from './tag.entity'
import type { TagsRepository } from './tags.repository'

export class TagsService extends BaseService<TagEntity> {
    constructor(private rep: TagsRepository) {
        super(rep)
    }

    async getTaggedPersons(
        from: Date,
        to: Date,
        lastEventBased: boolean,
        tag: string = '',
        rangeFrom: number,
        rangeTo: number,
    ) {
        if (!rangeFrom) rangeFrom = 0
        if (!rangeTo) rangeTo = 0
        return await this.rep.getTaggedPersons(from, to, lastEventBased, tag, rangeFrom, rangeTo)
    }

    async addPerson(tagId: string, personId: string) {
        return await this.rep.addPerson(tagId, personId)
    }

    async removePerson(tagId: string, personId: string) {
        return await this.rep.removePerson(tagId, personId)
    }
}
